import React from 'react';

import * as styles from './FigureRenderer.css';

type Props = {
  children?: React.ReactNode;
  'data-width'?: string;
  'data-layout'?: string;
  'data-crop'?: string;
};

function getCropStyles(cropStr: string) {
  const [x, y, w, h] = cropStr.split(',').map(Number);
  if (w >= 100 && h >= 100 && x <= 0 && y <= 0) return null;

  return {
    container: {
      overflow: 'hidden' as const,
      width: '100%',
    },
    img: {
      width: `${10000 / w}%`,
      maxWidth: 'none' as const,
      marginLeft: `${-(x / w) * 100}%`,
      marginTop: `${-(y / h) * 100}%`,
      display: 'block' as const,
    },
  };
}

export default function FigureRenderer(props: Props) {
  const width = props['data-width'];
  const layout = props['data-layout'] || 'full';
  const cropStr = props['data-crop'];
  const isRow = layout === 'row';
  const cropStyles = cropStr ? getCropStyles(cropStr) : null;

  return (
    <figure
      className={isRow ? styles.figureRow : styles.figure}
      style={{ maxWidth: width ? `${width}%` : undefined }}
    >
      {React.Children.map(props.children, (child) => {
        if (!React.isValidElement(child)) return child;

        // Apply crop mask to images
        const childProps = child.props as any;
        if (child.type === 'img' || childProps?.src) {
          if (cropStyles) {
            return (
              <div style={cropStyles.container}>
                {React.cloneElement(child as React.ReactElement<any>, {
                  style: { ...cropStyles.img, height: 'auto', borderRadius: '4px' },
                })}
              </div>
            );
          }
        }

        return child;
      })}
    </figure>
  );
}
